"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _sliderStyleTypes = require("./sliderStyleTypes");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultProps = {
  componentName: "basicSlider",
  cms: {
    style: {
      // titleColor: "Title color",
      textTransform: "Text transform",
      contentWidth: "Content width",
      contentPosition: "Position"
    },
    links: {
      slideOneLinkTitle: "Slide one link",
      slideOneUrl: "slide one url",
      slideTwoLinkTitle: "Slide two link",
      slideTwoUrl: "slide two url",
      slideThreeLinkTitle: "Slide three link ",
      slideThreeUrl: "Slide three url"
    },
    content: {
      slideOne: "Slide one quote",
      slideOneSubTitle: " Slide one title",
      slideOneLinkTitle: "Slide one link text",
      slideOneUrl: "Slide one link url",

      slideTwo: "Slide two quote",
      slideTwoSubTitle: "Slide two subtitle",
      slideTwoLinkTitle: "Slide two link text",
      slideTwoUrl: "Slide two url",

      slideThree: "Slide three quote",
      slideThreeSubTitle: "Slide three subtitle",
      slideThreeLinkTitle: "Slide three link text",
      slideThreeUrl: "Slide three url"
    },
    media: {
      oneImage: "Slide image one url",
      altOne: "Slide image one alt text",
      twoImage: "Slide image two",
      altTwo: "Slide image two alt text",
      threeImage: "Slide image three",
      altThree: "Slide image three alt text",
      slideOneUrl: "Slide one refer link",
      slideTwoUrl: "Slide two refer link",
      slideThreeUrl: "Slide three refer link"
    }
  },
  styleType: {
    style: {
      // titleColor: { type: "color" },
      textTransform: _extends({}, _sliderStyleTypes.transform),
      contentWidth: { type: "textField" },
      contentPosition: _extends({}, _sliderStyleTypes.position)
    },
    content: {
      media: {
        logo: "input",
        logoAlt: "input",
        slideOneUrl: "input",
        slideTwoUrl: "input",
        slideThreeUrl: "input"
      }
    }
  },
  props: _defineProperty({
    style: {
      // titleColor: "#fff",
      textTransform: "uppercase",
      contentWidth: "600",
      contentPosition: "left"
    },
    links: {
      slideOneLinkTitle: "learn more",
      slideOneUrl: "",
      slideTwoLinkTitle: "learn more",
      slideTwoUrl: "",
      slideThreeLinkTitle: "learn more",
      slideThreeUrl: ""
    },
    content: {
      slideOne: "<span>Limits are Exist Only in the Mind</span>",
      slideOneSubTitle: "<span>Lorem Ipsum is simply dummy text of the printing and typesetting industry</span>",

      slideTwo: "<span>Limits are Exist Only in the Mind</span>",
      slideTwoSubTitle: "<span>Lorem Ipsum is simply dummy text of the printing and typesetting industry</span>",

      slideThree: "<span>Limits are Exist Only in the Mind</span>",
      slideThreeSubTitle: "<span>Lorem Ipsum is simply dummy text of the printing and typesetting industry</span>"
    },
    media: {
      oneImage: "https://ik.imagekit.io/marketcube/platform/storybook/dd.jpg",
      altOne: "alt text",
      twoImage: "https://ik.imagekit.io/marketcube/platform/storybook/dd2.jpg",
      altTwo: "alt text",
      threeImage: "https://ik.imagekit.io/marketcube/platform/storybook/dd3.jpg",
      altThree: "alt text"
    }
  }, "media", {
    oneImage: "https://ik.imagekit.io/marketcube/platform/storybook/dd.jpg",
    altOne: "alt text",
    twoImage: "https://ik.imagekit.io/marketcube/platform/storybook/dd2.jpg",
    altTwo: "alt text",
    threeImage: "https://ik.imagekit.io/marketcube/platform/storybook/dd3.jpg",
    altThree: "alt text"
  })
};
exports.default = defaultProps;